import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import PropTypes from 'prop-types';
import { CHOOSE_ADD } from '../addressUtils/addressConstants';
import { isRequired } from '../../../utils/validation';

const ChooseAddressComponent = ({ type, chooseAddressHeading, formValues }) => {
  return (
    <Content>
      {({ globalRadioError, liveInUK, radioFieldYes = '', radioFieldNo = '' }) => (
        <Field name={`${type}.${CHOOSE_ADD}`} subscription={{ touched: true, error: true }}>
          {({ meta: { touched, error } }) => (
            <GenericFieldWrapper
              name={`${type}.${CHOOSE_ADD}`}
              title={chooseAddressHeading || liveInUK}
              validationMessage={touched && !!error ? globalRadioError : ''}
            >
              <Field
                name={`${type}.${CHOOSE_ADD}`}
                value={radioFieldYes}
                type="radio"
                validate={isRequired}
              >
                {({ input }) => (
                  <GenericRadio.InlineSet
                    groupName={`${type}_id`}
                    items={[
                      { id: radioFieldYes, labelText: radioFieldYes },
                      { id: radioFieldNo, labelText: radioFieldNo }
                    ]}
                    onChange={selectedId => input.onChange(selectedId)}
                    selectedId={formValues[type] ? formValues[type].Choose : null}
                  />
                )}
              </Field>
            </GenericFieldWrapper>
          )}
        </Field>
      )}
    </Content>
  );
};

ChooseAddressComponent.propTypes = {
  type: PropTypes.string.isRequired
};

export default ChooseAddressComponent;
